// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"96ab3439","96":"71124c7d","99":"297cbe53","211":"c8840c57","230":"42442aca","406":"15f40565","466":"d1a14178","529":"4d53f93e","638":"b138ffc2","693":"071bf82e"}[chunkId] + ".chunk.js";
};